/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type {SubscriptionDtoListSuccessDataResult} from '../models/SubscriptionDtoListSuccessDataResult'

import type {CancelablePromise} from '../core/CancelablePromise'
import {OpenAPICouponCenter} from 'rest'
import {request as __request} from '../core/request'

export class SubscriptionService {
  /**
   * @param websiteId
   * @returns SubscriptionDtoListSuccessDataResult Success
   * @throws ApiError
   */
  public static getApiSubscriptionGetList(
    websiteId?: number
  ): CancelablePromise<SubscriptionDtoListSuccessDataResult> {
    return __request(OpenAPICouponCenter, {
      method: 'GET',
      url: '/api/v1/payment-methods/',
      query: {
        websiteId: websiteId,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    })
  }
}
